<template>
  <v-alert color="primary" :value="show" >
      <span><strong class="white--text">Notice: </strong>{{alertText}}</span>
  </v-alert>
</template>
<script>
import firebase from 'firebase/app'
import 'firebase/database'
export default {
  data: () => ({
    show: false,
    alertText: null
  }),
  created () {
    firebase.database().ref('appData/alert').once('value')
      .then(result => {
        const val = result.val()
        this.alertText = val.msg
        if (val.visible === true) {
          this.show = true
        }
      })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/NoticeAlert.vue